
define('ldsh!modules/stats/templates/listing_item', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (showItem) {;
__p += '\n  <td class="ed-table-name-td">\n    ' +
((__t = ( company )) == null ? '' : __t) +
'\n  </td>\n  <td class="ed-table-name-td">\n    ' +
((__t = ( visitors )) == null ? '' : __t) +
'\n  </td>\n  <td class="ed-table-name-td">\n    ' +
((__t = ( visits )) == null ? '' : __t) +
'\n  </td>\n  <td class="ed-table-name-td">\n    ' +
((__t = ( convert )) == null ? '' : __t) +
'\n  </td>\n  <td class="ed-table-name-td">\n    ' +
((__t = ( pages )) == null ? '' : __t) +
'\n  </td>\n  ';
 } ;


}
return __p
};});

